import React from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import {
  capitalizeWords,
  finderSpecialityByName,
} from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import { specialitiesState } from "./state/atoms";
import SucursalIcon from "src/shared/icons/SucursalIcon";
import EspecialidadIcon from "src/shared/icons/EspecialidadIcon";

const AutocompleteSpecialities = ({ size = "small", styles }) => {
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const specialities = useRecoilValue(specialitiesState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState,
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState,
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-especialidad"
        text="Especialidad"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-especialidad"
        options={
          specialities?.length > 0
            ? specialities.map((option) => `${option.espNombre}`)
            : []
        }
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.specialitySelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findSpeciality = finderSpecialityByName(specialities, value);
            setFilterSearchSelected({
              ...filterSearchSelected,
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: value,
                code: findSpeciality?.espCodigo,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Especialidad" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <EspecialidadIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteSpecialities;
